export default function useFilters() {
  const dom = useDom();
  const route = useRoute();
  const queryParams = ref(new URLSearchParams(dom?.window.location.search));
  const tags = route.query['tags']?.toString();

  /***
   * @deprecated Use `setParams` from useQueryParams instead.
   */
  function addOrUpdateQueryParam(key: string, value: string) {
    if (!import.meta.client) {
      return;
    }
    queryParams.value.set(key, value);

    const newUrl = `${dom?.window.location.pathname}?${queryParams.value.toString()}`;
    dom?.window.history.replaceState({}, '', newUrl);
  }

  /**
   * @deprecated Use `removeParams` from useQueryParams instead.
   */
  function clearQueryParams() {
    if (!import.meta.client) {
      return;
    }
    queryParams.value = new URLSearchParams();

    const newUrl = `${dom?.window.location.pathname}`;
    dom?.window.history.replaceState({}, '', newUrl);
  }

  return {
    addOrUpdateQueryParam,
    clearQueryParams,
    tags
  };
}
